import { cn } from "@/lib/utils";

/**
 * The one page-level loading indicator: the brand ring of the boot loader in
 * index.html, centred on the screen. Every loading stage of a page (app boot,
 * route, then the page's own data) uses it, so a reload shows one spinner that
 * stays put instead of several in different places. Inline and button loading
 * keep their small spinners.
 */
export function PageSpinner({ className }: { className?: string }) {
  return (
    <div
      role="status"
      className={cn(
        "pointer-events-none fixed inset-0 flex items-center justify-center",
        className,
      )}
    >
      <div className="size-10 animate-spin rounded-full border-[3px] border-gray-200 border-t-[#1daf8d] dark:border-gray-700 dark:border-t-[#1daf8d]" />
    </div>
  );
}
